"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var IconButton = function IconButton(_ref) {
  var text = _ref.text,
    icon = _ref.icon,
    disabled = _ref.disabled,
    onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
    title: text,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
      onClick: onClick,
      disabled: disabled,
      children: icon
    })
  });
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(IconButton);